import * as ApiHelper from "~/common/utils/ApiHelper";
import { format } from "~/common/utils/ApiHelper";
import { type PreviewItem } from "~/features/bulkAddToCart/types/models";
import { type PreviewItemDTO } from "~/features/bulkAddToCart/types/dtos";
import { transformPreviewItem } from "~/features/bulkAddToCart/utils/transformers";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export async function updatePreviewEntryBulk(entries: PreviewItem[]): Promise<PreviewItem[]> {
  const apiUrl = resolveApiUrl(`/bulkupload/updateEntryBulk`);

  const body = {
    entries: entries.map((entry, index) => ({
      position: index,
      product: {
        productId: entry.productId,
        quantity: entry.quantity,
        targetPrice: entry.targetPrice,
        comment: entry.comment,
        priceReference: entry.priceReference,
        customerOrderNumber: entry.customerOrderNumber,
        requestDeliveryDate: entry.requestedDeliveryDate ? format(entry.requestedDeliveryDate) : undefined,
      },
    })),
  };

  const response = await fetch(apiUrl, {
    body: JSON.stringify(body),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  });

  if (!response.ok) {
    throw new Error(`Failed to update: ${response.status}`);
  }

  const data: PreviewItemDTO[] = (await response.json()) ?? [];

  return data.map(transformPreviewItem);
}

export async function updatePreviewEntry(index: number, entry: PreviewItem): Promise<PreviewItem[]> {
  const apiUrl = resolveApiUrl(`/bulkupload/updateEntryBulk`);

  const body = {
    entries: [
      {
        position: index,
        product: {
          productId: entry.productId,
          quantity: entry.quantity,
          targetPrice: entry.targetPrice,
          comment: entry.comment,
          priceReference: entry.priceReference,
          customerOrderNumber: entry.customerOrderNumber,
          requestDeliveryDate: entry.requestedDeliveryDate ? format(entry.requestedDeliveryDate) : undefined,
        },
      },
    ],
  };

  const response = await fetch(apiUrl, {
    body: JSON.stringify(body),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  });

  if (!response.ok) {
    throw new Error(`Failed to update: ${response.status}`);
  }

  const data: PreviewItemDTO[] = (await response.json()) ?? [];

  return data.map(transformPreviewItem);
}
